App.filter('isOver80FromBirthdate', function () {
    return function (date) {
        date = date || '';
        if (date) {
			var date = new Date(date);
        	var preciseMiliseconds = new Date(date.getFullYear() + 80, date.getMonth(), date.getDate()).getTime();
        	var nowMiliseconds = new Date().getTime();

            console.log(preciseMiliseconds);

        	if (preciseMiliseconds > nowMiliseconds) {
        		return false;
        	} else {
        		return true;
        	}

        } else {
        	return false;
        }
        return false;
    };
});